/** @jsx jsx */
import { useRef, useState, useEffect } from "react"
import { jsx, Layout as BaseLayout, Main, Container } from "theme-ui"
import { Global } from "@emotion/core"

import global from "~theme/global"
import { Header } from "gatsby-theme-docz/src/components/Header"
import { Sidebar } from "gatsby-theme-docz/src/components/Sidebar"
import * as styles from "./styles"
import { makeStyles } from "@material-ui/styles"
import * as colors from "../../theme/colors.js"

const useStyles = makeStyles({
  content: {
    "& h2": {
      borderBottom: "1px solid #ccc"
    },
    "& h1": {
      paddingTop: 36,
      paddingBottom: 36,
      paddingLeft: 36,
      paddingRight: 36,
      backgroundColor: colors.grayExtraLight
    },
    "& h1.dark": {
      paddingTop: 36,
      paddingBottom: 36,
      paddingLeft: 36,
      paddingRight: 36,
      backgroundColor: colors.dark
    },
    "& img": { cursor: "pointer" },
    "& img.enlarged": {
      position: "fixed",
      zIndex: 9999,
      left: 0,
      top: 0,
      width: "100vw",
      height: "100vh",
      objectFit: "contain",
      backgroundColor: "rgba(0,0,0,0.5)"
    }
  }
})

export const Layout = ({ children }) => {
  const [open, setOpen] = useState(false)
  const nav = useRef()
  const c = useStyles()

  useEffect(() => {
    function handleImageClick() {
      if (this.className.includes("enlarged")) {
        this.className = this.className.replace(" enlarged", "")
      } else {
        this.className += " enlarged"
      }
    }
    const interval = setInterval(() => {
      const images = document.getElementsByTagName("img")
      for (const image of images) {
        if (!image.alt) continue
        image.removeEventListener("click", handleImageClick)
        image.addEventListener("click", handleImageClick)
      }
    }, 1000)
    return () => {
      clearInterval(interval)
    }
  })

  return (
    <BaseLayout sx={{ "& > div": { flex: "1 1 auto" } }} data-testid="layout">
      <Global styles={global} />
      <Main sx={styles.main}>
        <Header onOpen={() => setOpen(s => !s)} />
        <div sx={styles.wrapper}>
          <Sidebar
            ref={nav}
            open={open}
            onFocus={() => setOpen(true)}
            onBlur={() => setOpen(false)}
            onClick={() => setOpen(false)}
          />
          <Container
            sx={styles.content}
            style={{ maxWidth: 800 }}
            className={c.content}
            data-testid="main-container"
          >
            {children}
          </Container>
        </div>
      </Main>
    </BaseLayout>
  )
}
